import { Link, useSearchParams } from "react-router-dom";
import { ArrowLeft, ArrowRight, XCircle } from "lucide-react";
import { Seo } from "../components/site/Seo";

export default function PaymentCancel() {
  const [params] = useSearchParams();
  const eventSlug = params.get("event");

  return (
    <div data-testid="payment-cancel-page" className="pt-16 min-h-[70vh] flex items-center justify-center px-5">
      <Seo title="Checkout canceled — HyroxNinja" description="Your Stripe checkout was canceled. No charge was made." noindex />
      <div className="border border-white/10 bg-[#0c0c0c] p-8 sm:p-12 max-w-lg w-full text-center">
        <XCircle size={48} className="text-zinc-500 mx-auto mb-5" />
        <h1 className="font-head font-extrabold uppercase text-3xl mb-3">Checkout canceled</h1>
        <p className="text-zinc-400 text-sm leading-relaxed mb-7">
          No charge was made and no spot was taken. You can head back and try again whenever you're ready.
        </p>
        <div className="flex flex-wrap justify-center gap-3">
          {eventSlug ? (
            <Link to={`/events/${eventSlug}`} className="btn-volt" data-testid="payment-cancel-back-event">
              <ArrowLeft size={15} /> Back to the Event
            </Link>
          ) : (
            <Link to="/support" className="btn-volt" data-testid="payment-cancel-back-support">
              <ArrowLeft size={15} /> Back to Support
            </Link>
          )}
          <Link to="/events" className="btn-ghost" data-testid="payment-cancel-all-events">
            All Events <ArrowRight size={15} />
          </Link>
        </div>
      </div>
    </div>
  );
}
